import * as React from 'react';
import { RouteComponentProps } from 'react-router';
const DocumentTitle = require('react-document-title');

export default class RegistrationThankYou extends React.Component<RouteComponentProps> {

    public render() {
        return <React.Fragment>
            <DocumentTitle title='Thank You' />
            <br/>
            <h2 style={{ textAlign:"center" }} >Thank you for registering!</h2>
            <h5 style={{ textAlign:"center" }} >Your form is being processed.</h5>
            <p className="mt-5 mb-3 text-muted text-center">&copy; {(new Date()).getFullYear()} Daycarium</p>
        </React.Fragment>
    }
}
